export function CurrencyFormatter(total: number) {
  return total?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

export function CurrencyFormatter2(total: number) {
  return total?.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}
